type Props = {
  name: string;
  alt: string;
  className?: string;
  sizes?: string;
  loading?: "eager" | "lazy";
  fetchPriority?: "high" | "low" | "auto";
  width?: number;
  height?: number;
};

export function ResponsiveImage({
  name,
  alt,
  className,
  sizes = "100vw",
  loading = "lazy",
  fetchPriority = "auto",
  width = 1536,
  height = 1024,
}: Props) {
  const set = (format: "avif" | "webp") =>
    [480, 768, 1024, 1536].map((value) => `/images/${name}-${value}.${format} ${value}w`).join(", ");
  return (
    <picture className={className}>
      <source srcSet={set("avif")} type="image/avif" sizes={sizes} />
      <source srcSet={set("webp")} type="image/webp" sizes={sizes} />
      <img
        src={`/images/${name}-1024.webp`}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        fetchPriority={fetchPriority}
      />
    </picture>
  );
}
